import { readAccessTokenFromLocation } from './utils';

export const SDK_AUTH_STORAGE_KEY = 'joygamesSdkAuth';

/** Token game trên URL — khóa ngay khi load trang, không đổi trong phiên. */
const GAME_URL_ACCESS_TOKEN =
  typeof window !== 'undefined' ? readAccessTokenFromLocation() : null;

export type SdkAuthContext = {
  accessToken: string;
  productId: string;
  deviceId: string;
};

export function getGameUrlAccessToken(): string | null {
  return GAME_URL_ACCESS_TOKEN;
}

export function isGameTokenSession(): boolean {
  return Boolean(GAME_URL_ACCESS_TOKEN);
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function resolveSdkAuthContext(
  accessToken: string,
  productCode: string,
  search = window.location.search
): SdkAuthContext {
  const params = new URLSearchParams(search);
  const jwt = decodeJwtPayload(accessToken);
  const productId =
    params.get('productCode')
    || productCode
    || String(jwt?.productId ?? '');
  const deviceId =
    params.get('deviceId')
    || String(jwt?.deviceId ?? '');
  return { accessToken, productId, deviceId };
}

export function persistSdkAuthContext(ctx: SdkAuthContext): void {
  sessionStorage.setItem(SDK_AUTH_STORAGE_KEY, JSON.stringify(ctx));
}

export function getStoredSdkAuthContext(): SdkAuthContext | null {
  try {
    const raw = sessionStorage.getItem(SDK_AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getSdkAuthHeaders(): Record<string, string> {
  const ctx = getStoredSdkAuthContext();
  if (!ctx) return {};
  const headers: Record<string, string> = {};
  if (ctx.productId) headers['X-Product-Id'] = ctx.productId;
  if (ctx.deviceId) headers['X-Device-Id'] = ctx.deviceId;
  return headers;
}

/** Khởi tạo context auth từ URL game (gọi một lần lúc App mount). */
export function initGameTokenSession(productCode: string): SdkAuthContext | null {
  const token = getGameUrlAccessToken();
  if (!token) return null;
  const ctx = resolveSdkAuthContext(token, productCode);
  persistSdkAuthContext(ctx);
  return ctx;
}

/** Token dùng cho mọi API payment — luôn ưu tiên token URL game. */
export function getEffectiveAccessToken(fallback = ''): string {
  return getGameUrlAccessToken() || fallback;
}
